import { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

import { Tabs, TabsStrategy } from '../../components/Tabs';
import { Breadcrumbs } from '../../components/Breadcrumbs';
import {
  PATH_EXTERNAL_ORGANIZATIONS,
  PATH_EXTERNAL_PEOPLE,
  PATH_EXTERNAL_THIRD_PARTIES_DEFAULT,
  PATH_EXTERNAL_THIRD_PARTIES_DISABLED,
} from '../../app/constants/paths.constant';
import { Page } from '../../contexts/NavigationContext/enums/page.enum';
import { useNavigationContext } from '../../contexts/NavigationContext/hooks/useNavigationContext.hook';
import { buildDocumentTitle } from '../../utils/document-title.util';
import { PageTitle } from '../../components/PageTitle';

import { PeopleTabPanel } from './People';
import { OrganizationsTabPanel } from './Organizations';
import { DisabledTabPanel } from './Disabled';

export const ExternalThirdPartiesPage = () => {
  const { setPage } = useNavigationContext();

  useEffect(() => {
    setPage(Page.ExternalThirdParties);
  }, [setPage]);

  return (
    <>
      <Helmet>
        <title>{buildDocumentTitle('Liste des Tiers')}</title>
      </Helmet>
      <Breadcrumbs
        paths={[
          {
            to: PATH_EXTERNAL_THIRD_PARTIES_DEFAULT,
            label: 'tiers',
            key: 'thirdParties',
          },
        ]}
      />
      <PageTitle title="Liste des Tiers" />
      <Tabs
        id="external-third-parties-tabs"
        strategy={TabsStrategy.RouterConnected}
        tabs={[
          {
            key: 'organizations',
            label: 'Organisations',
            panel: <OrganizationsTabPanel isInternal={false} />,
            to: PATH_EXTERNAL_ORGANIZATIONS,
          },
          {
            key: 'people',
            label: 'Personnes',
            panel: <PeopleTabPanel isInternal={false} />,
            to: PATH_EXTERNAL_PEOPLE,
          },
          {
            key: 'disabledThirdParties',
            label: 'Tiers Inactifs',
            panel: <DisabledTabPanel isInternal={false} />,
            to: PATH_EXTERNAL_THIRD_PARTIES_DISABLED,
          },
        ]}
        title="Onglets de l'écran de Liste des Tiers"
      />
    </>
  );
};
